'use strict';

exports.__esModule = true;
exports.OFF = exports.ERROR = exports.WARN = exports.INFO = exports.DEBUG = exports.TRACE = undefined;

var _LogLevel = require('./LogLevel');

var _LogLevel2 = _interopRequireDefault(_LogLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Predefined logging levels.
var TRACE = exports.TRACE = new _LogLevel2['default']('trace', 0);
var DEBUG = exports.DEBUG = new _LogLevel2['default']('debug', 1);
var INFO = exports.INFO = new _LogLevel2['default']('info', 2);
var WARN = exports.WARN = new _LogLevel2['default']('warn', 3);
var ERROR = exports.ERROR = new _LogLevel2['default']('error', 4);
var OFF = exports.OFF = new _LogLevel2['default']('off', 9999);